import { BaseEnvironment, MetadataWriterConfig } from "./types";

// Shared environment configuration
export const baseEnvironment: Omit<BaseEnvironment, "ENV"> = {
  APP_NAME: 'ViSOL',
  USE_CONNECT_PLATFORM: true,
  DEBUG_AUTH_FLOW: false,
  DEBUG_LOADING_FLOW: false,
  withCredentials: true,
  production: true,
};

// Special token used to bypass recatcha in Local / Development environments
export const AUTH_CAPTCHA_BYPASS_TOKEN = "a4adcd8a-7aaa-c2de-7d73-3fde7c85e9ee";

// Settings for Development/Staging/Production METADATA_WRITER
export const METADATA_WRITER: MetadataWriterConfig = {
  publicKeyPath: 'assets/offline/metadata-writer/public.pem',
  privateKeyPath:'assets/offline/metadata-writer/private.pem',
  configPath:'assets/offline/metadata-writer/ExifTool_config',
  exifToolPath:'assets/offline/metadata-writer/exiftool-vendored.exe/bin/exiftool.exe',
  legacyExifReaderPath:'assets/offline/ExifMetadataReader/OSC.ExifMetadataReaderWrapper.exe'
};
